import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ProcessReport} from "../model/reports.model";

@Injectable({
  providedIn: 'root'
})
export class ReportsManagerService {

  constructor(
    private http: HttpClient
  ) { }

  loadStatuses(owner: String) {
    return this.http.get<ProcessReport[]>(environment.apiPrefix + "/statuses/" + owner)
  }

  loadReports(owner: string, vertical: string, code: string) {
    let path = "/reports" + "/" + owner + "/" + vertical + "/" + code
    return this.http.get<ProcessReport[]>(environment.apiPrefix + path)
  }

}
